// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bdc68","fullscreen":"_57ddf","iframe":"c0a43","video":"_18abf"};